<div class="admin" *ngIf="isAdmin">
  <button class="wire-btn skalaki" (click)="answerModal(answerTemplate)">Answer</button>
  <button class="wire-btn" (click)="deleteReview()">Delete</button>
</div>
<div class="review-card" [class.mobile]="isMobile" [class.tablet]="isTablet">
  <div class="header">
    <div class="avatar">
      {{review.name[0].toUpperCase()}}
    </div>
    <div class="info">
      <span class="name">
        {{review.name}}
      </span>
      <span class="date">
        {{getMonth(review.stayStartDate)}}
      </span>
    </div>
  </div>
  <div class="review">
    <div class="rating">
      <span>
        <app-rating [rating]="review.evaluation"></app-rating>
      </span>
      <span class="date">
        {{review.createdAt | date:'dd/MM/yyyy'}}
      </span>
    </div>
    <p class="comment">
      {{review.comment}}
    </p>
    <div class="footer" *ngIf="review.answer">
      <div class="wire-btn" (click)="showResponse()">{{'Réponse du propriétaire' | translate}}</div>
    </div>
  </div>
</div>
<div class="review-card answer" *ngIf="review.answer && _showResponse" [class.mobile]="isMobile"
  [class.tablet]="isTablet">
  <div class="close" (click)="showResponse()">
    <i class="fa fa-times"></i>
  </div>
  <div class="header">
    <div class="avatar">
      B
    </div>
    <div class="info">
      <span class="name">
        Bruno
      </span>
      <span class="date">
        {{'Propriétaire' | translate}}
      </span>
    </div>
  </div>
  <div class="review">
    <p class="comment">
      {{review.answer}}
    </p>
  </div>
</div>

<ng-template #answerTemplate>
  <div class="modal-content">
    <div class="header">
      Answer
    </div>
    <div class="content">
      <div class="form">
        <div class="form-group">
          <textarea rows="12" [(ngModel)]="this.reviewModel.answer"></textarea>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveReview()">Save</button>
      <button class="wire-btn default" (click)="close()">Cancel</button>
    </div>
  </div>
</ng-template>

<p-confirmDialog header="Delete Review" icon="pi pi-exclamation-triangle"></p-confirmDialog>